export default __webpack_public_path__ + "static/media/kick.79e198d6.png";